<template>
    <div class="equity-common-content">
        <div class="e-common-frames">
            <div class="e-top e-common-block">
                <div class="e-common-lr">
                    <div class="e-left">
                        <img src="@/assets/images/e-tyfw-icon@2x.png" alt="">
                    </div>
                    <div class="e-right">
                        <h3>体检服务</h3>
                        <p>每年为您提供免费的全身体检服务,您可转让亲友使用。</p>
                    </div>
                </div>
            </div>
            <div class="e-bottom e-common-block">
                <h2>温馨提示</h2>
                <p class="bold">细则1</p>
                <p>世界白金鑫卡持卡人全年尊享1次体检服务,并可转赠亲友使用。</p>
                <p class="bold">细则2</p>
                <p>本行将在您激活人民币卡后的3个工作日内为您开通权益服务。</p>
                <p class="bold">细则3</p>
                <p>当您需要预约体检服务时,请提前7个自然日通过本行信用卡微公众号权益平台预约服务；如您需要修改或取消该服务,请务必提前2个工作日通过微信公众号权益平台取消,否则视作您已使用本次服务,并扣减相应权益。
                </p>
                <p class="bold">细则4</p>
                <p>体检中心地址请以本行信用卡微信公众号权益平台服务预约显示为准。</p>
                <p class="bold">细则5</p>
                <p>体检有空腹项目,请体检者于前一天晚上8点后禁食。</p>
                <p class="bold">细则6</p>
                <p>到达预约的体检中心后需出示登记人身份证明文件即可进行身体检査。</p>
                <p class="bold">细则7</p>
                <p>体检时间：上午7:30-10:00,空腹前往体检中心,10点以后体检中心不再接待登记。</p>
                <p class="bold">细则8</p>
                <p>体检报告的索取：</p>
                <p>电子报告：体检后3-5个工作日内您将会收到短信告知体检报告已上传,凭预约时的卡号和密码登录手机APP爱康体检宝或登录http://www.ikang.com即可査看并下载体检报告,收短信的手机是您预约时预留的手机号码。
                </p>
                <p class="m-2">纸质报告：体检后5-7个工作日会收到纸质的体检报告,体检中心会将密封的体检报告统一寄送到指定地址。</p>
            </div>
            <div class="banner-detail-btn" @click="tjxmPush"><img src="@/assets/images/bjx/banner_detail_tjxm.jpg" alt="">
            </div>
            <div class="banner-detail-btn" @click="tjjgPush"><img src="@/assets/images/bjx/banner_detail_tjjg.jpg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods:{
            tjxmPush(){
                this.$test('bjx tjxm-banner')
                // console.log('白金鑫体检项目')
                this.$router.push('/servicetable/tjxm')
            },
            tjjgPush(){
                this.$test('bjx tjjg-banner')
                // console.log('白金鑫体检机构')
                this.$router.push('/servicetable/tjjg')
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>